import React, { useEffect } from "react";
import Card from "../../../../componets/Card";
import { useAppDispatch } from "../../../../store/hooks";
import { useSearchParams } from "react-router-dom";
import { queryParams } from "../../../../helpers/UrlHelpers";
import { fetchAddons } from "../../../../actions/mine_craft/addonsActions";
import AddonsList from "../../Addons/_partials/_List";

const LIMIT = 20;

const _Posts = ({ userId }: { userId: number | undefined }) => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage = queryParams.getInt(searchParams,'page') || 1;

  useEffect(() => {
    if (!userId) {
      return;
    }

    const params: any = {
      limit: LIMIT,
      offset: (currentPage - 1) * LIMIT,
      user_id: userId
    };

    dispatch(fetchAddons(params))
  }, [userId, currentPage, dispatch])

  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Posts</h4>

        <AddonsList limit={LIMIT} />
      </Card>
    </>
  );
}

export default _Posts;
